/**
 * DevExtreme (esm/__internal/grids/data_grid/m_widget.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import DataGrid from "./m_widget_base";
import "./module_not_extended/state_storing";
import "./module_not_extended/selection";
import "./module_not_extended/column_chooser";
import "./grouping/m_grouping";
import "./module_not_extended/master_detail";
import "./m_editing";
import "./module_not_extended/editing_row_based";
import "./module_not_extended/editing_form_based";
import "./module_not_extended/editing_cell_based";
import "./module_not_extended/validating";
import "./module_not_extended/virtual_scrolling";
import "./module_not_extended/filter_row";
import "./module_not_extended/header_filter";
import "./module_not_extended/filter_sync";
import "./module_not_extended/filter_builder";
import "./module_not_extended/filter_panel";
import "./module_not_extended/search";
import "./module_not_extended/pager";
import "./module_not_extended/columns_resizing_reordering";
import "./module_not_extended/keyboard_navigation";
import "./keyboard_navigation/m_headers_keyboard_navigation";
import "./keyboard_navigation/m_group_panel_keyboard_navigation";
import "./summary/m_summary";
import "./module_not_extended/sticky_columns";
import "./module_not_extended/column_fixing";
import "./module_not_extended/adaptivity";
import "./module_not_extended/virtual_columns";
import "./export/m_export";
import "./focus/m_focus";
import "./module_not_extended/row_dragging";
export default DataGrid;